<template>
    <div id="marketing_analytics_grid">
      <InfoGrid :columns="3">
        <ContainerInfoItem
          v-for="(data, key) in analyticsData"
          :key="key"
          source="marketing_analytics_grid"
          :title="data.title"
          :description="range?.label || ''"
          :value="formatAnalyticsValue(data.value, data.unit)"
          :is-loading="data.isLoading"
        />
      </InfoGrid>
    </div>
  </template>

  <script setup>
  import { computed, reactive, watch } from "vue";
  import { formatAnalyticsValue } from "@/src/utils/analyticUtils.js";
  import store from "@/src/store/index.js";
  import InfoGrid from "@/src/components/info_components/InfoGrid.vue";
  import ContainerInfoItem from "@/src/components/info_components/ContainerInfoItem.vue";
  import { useAnalyticsRefresh } from "@/src/composables/useAnalyticsRefresh.js";
  import { marketingAnalyticsDataStructure, marketingActions } from "@/src/constants/analyticConstants.js";
  import AnalyticService from "@/src/api/AnalyticService.js";

  const props = defineProps({
    channelType: { type: String, default: "all" },
  });

  const range = computed(() => store.getters["analytics/getRange"]);
  const userIds = computed(() => store.getters["analytics/getUserIds"]);
  const teamIds = computed(() => store.getters["analytics/getTeamIds"]);


  const analyticsData = reactive(
  marketingAnalyticsDataStructure.map((item) => ({ ...item }))
);

const fetchAnalytics = async () => {
    analyticsData.forEach((item) => {
      item.isLoading = true;
    });

    try {
      const params = {
        user_id: userIds.value,
        team_id: teamIds.value,
        start_date: range.value?.start,
        end_date: range.value?.end,
      };

      if (props.channelType && props.channelType !== "all") {
        params.channel_type = props.channelType.toUpperCase();
      }

      const response = await AnalyticService.V2.fetchMarketingEmailCount(params);
      if (response?.success || response) {
        const data = response?.data || response;
        
        const mapping = {
          [marketingActions.TOTAL_CAMPAIGNS_SENT]: data.total_sent || 0,
          [marketingActions.TOTAL_EMAIL_CAMPAIGNS_SENT]: data.channel_counts?.EMAIL || 0,
          [marketingActions.TOTAL_WHATSAPP_CAMPAIGNS_SENT]: data.channel_counts?.WHATSAPP || 0,
        };
        
        analyticsData.forEach((item) => {
          item.value = mapping[item.id] || data?.[item.id] || 0;
        });
      }
    } catch (error) {
      console.error("An error occurred while fetching analytics: ", error);
    } finally {
      analyticsData.forEach((item) => {
        item.isLoading = false;
      });
    }
  };

  watch([range, () => props.channelType], () => {
    if (range.value?.start && range.value?.end) {
      fetchAnalytics();
    }
  }, { deep: true, immediate: true });

  useAnalyticsRefresh(fetchAnalytics, [range, userIds, teamIds, () => props.channelType]);
  </script>
